import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipComment from "./ElementTooltipComment";
import ElementTooltipName from "./ElementTooltipName";
import ElementTooltipSeparator from "./ElementTooltipSeparator";

const _limit = 20;

function TooltipNode({ node, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  const _name = nodeUtils.getName(node);

  if (!_name) {
    return null;
  }

  const _comment = nodeUtils.getComment(node);

  if (_name.length < _limit && !_comment) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipName node={node} />
      {_comment && (
        <>
          <ElementTooltipSeparator />
          <ElementTooltipComment node={node} />
        </>
      )}
    </DefaultTooltip>
  );
}

export default TooltipNode;
